var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allindex"},[_c('Left',{ref:"Left"}),_c('Top',{ref:"Top"}),_c('div',{staticClass:"all-main",class:_vm.mainActive ? 'active' :''},[_c('div',{staticClass:"main-index"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }